var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-excel-xlsx',{attrs:{"data":_vm.tableData,"columns":_vm.tableColumns,"filename":_vm.filename,"sheetname":_vm.filesheet}},[_c('el-button',{attrs:{"size":_vm.size,"type":_vm.color,"icon":_vm.icon,"disabled":_vm.disabled}},[_vm._v(" "+_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }